import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
import appConstants from './helper/appConstants'

moment.locale('zh-cn')

Vue.filter('NumberFormat', function(value) {
  if (!value) {
    return '0'
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat
})

Vue.filter('dayjs', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.filter('moment', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})
//商品状态名称
Vue.filter('productTypeName', function(value) {
  return appConstants.getTypeName(value, appConstants.getProductTypeList())
})
//订单状态名称
Vue.filter('OrderStateName', function(value) {
  return appConstants.getTypeName(value, appConstants.getOrderStatus())
})
Vue.filter('productSourcesName', function(value) {
  return appConstants.getTypeName(value, appConstants.getProductSources())
})
//用户标签类型
Vue.filter('userTagTypeName', function(value) {
  return appConstants.getTypeName(value, appConstants.getUserTagType())
})
//用户标签规则类型
Vue.filter('userTagRuleTypeName', function(value) {
  return appConstants.getTypeName(value, appConstants.getUserTagRuleType())
})
//性别
Vue.filter('sexTypeName', function(value) {
  return appConstants.getTypeName(value, appConstants.getSexType())
})
//用户详情类型
Vue.filter('userDetailTypeName', function(value) {
  return appConstants.getTypeName(value, appConstants.getUserDetailType())
})
//用户标签状态
Vue.filter('tagStatusName', function(value) {
  return appConstants.getTypeName(value, appConstants.getTagStatus())
})

Vue.filter('getModularContentName', function(value) {
  return appConstants.getTypeName(value, appConstants.getModularContentType())
})
// 图标类型
Vue.filter('getIconContentName', function(value) {
  return appConstants.getTypeName(value, appConstants.getIconContentType())
})
// 图标状态
Vue.filter('getIconStatusName', function(value) {
  return appConstants.getTypeName(value, appConstants.getIconStatusType())
})
// 数据权限
Vue.filter('dataPermissionsName', function(value) {
  return appConstants.getTypeName(value, appConstants.getDataPermissions())
})

// 最全商品
Vue.filter('getAllProductTypeName', function(value) {
  return appConstants.getTypeName(value, appConstants.getAllProductTypeList())
})
//二分审核状态
Vue.filter('staffAuditName', function(value) {
  return appConstants.getTypeName(value, appConstants.getStaffAuditList())
})
//二分状态
Vue.filter('staffStatusName', function(value) {
  return appConstants.getTypeName(value, appConstants.getStaffStatusList())
})
//收支名称
Vue.filter('incomeAndExpenditureName', function(value) {
  return appConstants.getTypeName(value, appConstants.getIncomeAndExpenditureCategories())
})
//资金流向
Vue.filter('capitalFlowName', function(value) {
  return appConstants.getTypeName(value, appConstants.getCapitalFlow())
})

//商品下架原因
Vue.filter('proInfoDrop', function(value) {
  return appConstants.getTypeName(value, appConstants.getProInfoDropReason())
})
//余额充值结果
Vue.filter('rechargeResultName', function(value) {
  return appConstants.getTypeName(value, appConstants.getRechargeResult())
})
//余额转账方式
Vue.filter('transferTypeName', function(value) {
  return appConstants.getTypeName(value, appConstants.getTransferType())
})
//资金流向
Vue.filter('capitalFlowsTypeName', function(value) {
  return appConstants.getTypeName(value, appConstants.getCapitalFlowsType())
})
//收入类别
Vue.filter('incomeTypeName', function(value) {
  return appConstants.getTypeName(value, appConstants.getIncomeType())
})
//支出类别
Vue.filter('expendTypeName', function(value) {
  return appConstants.getTypeName(value, appConstants.getExpendType())
})
//收支全类别
Vue.filter('incomeExpendTypeName', function(value) {
  return appConstants.getTypeName(value, appConstants.getIncomeExpendType())
})
//对账状态
Vue.filter('statementStatusName', function(value) {
  return appConstants.getTypeName(value, appConstants.getStatementStatus())
})
//已提交申请状态
Vue.filter('applyStatusName', function(value) {
  return appConstants.getTypeName(value, appConstants.getApplyStatus())
})

//报表中心 文件状态
Vue.filter('getFileStatusName', function(value) {
  return appConstants.getTypeName(value, appConstants.getFileTypeStatus())
})

//报表中心 文件状态
Vue.filter('getFileRecordStatusName', function(value) {
  return appConstants.getTypeName(value, appConstants.getFileRecordTypeStatus())
})
//调账类型
Vue.filter('getAccountRegulationTypeName', function(value) {
  return appConstants.getTypeName(value, appConstants.getAccountRegulationType())
})
//授信还款状态
Vue.filter('creditPaymentTypeName', function(value) {
  return appConstants.getTypeName(value, appConstants.getCreditPaymentType())
})
Vue.filter('preOrderStateName', function(value) {
  return appConstants.getTypeName(value, appConstants.getPreOrderStates())
})
//
Vue.filter('bookstatusFilter', function(value) {
  return appConstants.getTypeName(value, appConstants.getBookstatusFilter())
})
//商户类型
Vue.filter('merchantTypeName', function(value) {
  return appConstants.getTypeName(value, appConstants.merchantTypeFitter())
})
// 商户状态
Vue.filter('drawCashStatusName', function(value) {
  return appConstants.getTypeName(value, appConstants.drawCashStatus())
})
Vue.filter('livePlayerStateName', function(value) {
  return appConstants.getTypeName(value, appConstants.getLivePlayerStates())
})
//发票类型
Vue.filter('invoiceTypeName', function(value) {
  return appConstants.getTypeName(value, appConstants.getInvoiceType())
})
//发票状态
Vue.filter('invoiceStatusName', function(value) {
  return appConstants.getTypeName(value, appConstants.getInvoiceStatus())
})

// 虚拟直连订单
Vue.filter('orderDirectConnection', function(value) {
  return appConstants.getTypeName(value, appConstants.getOrderDirectConnection())
})

// 产品套餐状态
Vue.filter('getProOptionStatusStr', function(value) {
  return appConstants.getTypeName(value, appConstants.getProOptionStatus())
})
// 交通运输方式
Vue.filter('trafficName', function(value) {
  return appConstants.getTypeName(value, appConstants.getTrafficList())
})
// 数字转汉字
Vue.filter('chineseCharactersName', function(value) {
  return appConstants.getTypeName(value, appConstants.getChineseCharacters())
})
Vue.filter('auditorFilterStatus', function(value) {
  return appConstants.getTypeName(value, appConstants.getAuditorListStatus())
})
Vue.filter('fissionStatus', function(value) {
  return appConstants.getTypeName(value, appConstants.getFissionStatus())
})
// 畅联订单状态
Vue.filter('changLianOrderStateName', function(value) {
  return appConstants.getTypeName(value, appConstants.getChangLianOrderStates())
})
